<template>
  <div class="detail-container" >
     <video
        ref="videoRef"
        :src="videoUrl"
        muted
        autoplay
        loop
        playsinline
        preload="metadata"
        @click.stop
        :key="videoUrl"
      ></video>
    <div class="video-container">
      <div class="detail-content">
        <img :src="detailImage" :class="['detail-img', 'detail-img-' + detailId]" />
         <div class="ruhua-button" @click.stop="GotoRuHuaView"></div>
      </div>
    </div>

   
    <div v-if="showAlert" class="alert-overlay" @click="closeAlert">
      <div class="alert-content" @click.stop>
        <img :src="alertImage" class="alert-image" />
        <div class="alert-actions">
          <img :src="haibaoBtn" class="alert-btn" @click="onClickHaibao" />
          <img :src="jixuBtn" class="alert-btn" @click="onClickJixu" />
        </div>
      </div>
    </div>
      <div ref="poster_ref" class="alert-content poster-content" @click.stop>
        <img :src="alertImage" class="alert-image" />
        <img class="qrcode" :src="qrcode_url" alt="" srcset="">
      </div>
      <!-- 微信长按保存弹窗 -->
      <div v-if="showSaveDialog" class="save-dialog-overlay" @click="closeSaveDialog">
        <div class="save-dialog-content" @click.stop>
          <p class="save-dialog-text">长按下方图片保存到相册</p>
          <img :src="poster_url" class="save-dialog-image" />
          <p class="save-dialog-tip">长按保存图片</p>
          <button class="save-dialog-close" @click="closeSaveDialog">关闭</button>
        </div>
      </div>
  </div>
</template>

<script setup>
// @ is an alias to /src
import { useRouter, useRoute } from 'vue-router'
import { ref, computed, onMounted } from 'vue'
import html2canvas from "html2canvas"
import { showLoadingToast,closeToast,showToast } from 'vant';
import QRCode  from 'qrcode'
import * as qiniu from 'qiniu-js';
import haibaoBtn from '@/assets/detail/button_haibao.png'
import jixuBtn from '@/assets/detail/button_jixu.png'
import detail01 from '@/assets/detail/detailtext/detail01.png'
import detail02 from '@/assets/detail/detailtext/detail02.png'
import detail03 from '@/assets/detail/detailtext/detail03.png'
import detail04 from '@/assets/detail/detailtext/detail04.png'  
import detail05 from '@/assets/detail/detailtext/detail05.png'
import detail06 from '@/assets/detail/detailtext/detail06.png'
import detail07 from '@/assets/detail/detailtext/detail07.png'
import detail08 from '@/assets/detail/detailtext/detail08.png'
import detail09 from '@/assets/detail/detailtext/detail09.png'
import detail10 from '@/assets/detail/detailtext/detail10.png'
import alert01 from '@/assets/detail/detailalert/detailalert01.png'
import alert02 from '@/assets/detail/detailalert/detailalert02.png'
import alert03 from '@/assets/detail/detailalert/detailalert03.png'
import alert04 from '@/assets/detail/detailalert/detailalert04.png'
import alert05 from '@/assets/detail/detailalert/detailalert05.png'
import alert06 from '@/assets/detail/detailalert/detailalert06.png'
import alert07 from '@/assets/detail/detailalert/detailalert07.png'
import alert08 from '@/assets/detail/detailalert/detailalert08.png'
import alert09 from '@/assets/detail/detailalert/detailalert09.png'
import alert10 from '@/assets/detail/detailalert/detailalert10.png'

const router = useRouter()
const qrcode_url = ref('')
const poster_url = ref('')
const poster_ref = ref(null)
const route = useRoute()
const showAlert = ref(false)
const showSaveDialog = ref(false)
const detailId = computed(() => (typeof route.query.id === 'string' ? route.query.id : '01'))
const detailImages = {
  '01': detail01,
  '02': detail02,
  '03': detail03,
  '04': detail04,
  '05': detail05,
  '06': detail06,
  '07': detail07,
  '08': detail08,
  '09': detail09,
  '10': detail10
}
const alertImages = {
  '01': alert01,
  '02': alert02,
  '03': alert03,
  '04': alert04,
  '05': alert05,
  '06': alert06,
  '07': alert07,
  '08': alert08,
  '09': alert09,
  '10': alert10
}
import video01 from '@/assets/detail/video/video01.mp4'
import video02 from '@/assets/detail/video/video02.mp4'
import video03 from '@/assets/detail/video/video03.mp4'
import video04 from '@/assets/detail/video/video04.mp4'
import video05 from '@/assets/detail/video/video05.mp4'
import video06 from '@/assets/detail/video/video06.mp4'
import video07 from '@/assets/detail/video/video07.mp4'
import video08 from '@/assets/detail/video/video08.mp4'
import video09 from '@/assets/detail/video/video09.mp4'
import video10 from '@/assets/detail/video/video10.mp4'
const videoList = {
  '01': video01,
  '02': video02,
  '03': video03,
  '04': video04,
  '05': video05,
  '06': video06,
  '07': video07,
  '08': video08,
  '09': video09,
  '10': video10,
}
const detailImage = computed(() => detailImages[detailId.value] || detail01)
const alertImage = computed(() => alertImages[detailId.value] || alert01)
const videoUrl = computed(() => videoList[detailId.value] || video01)
const videoRef = ref(null)

function is_xhn(){
    //新湖南云判断
    var UA = window.navigator.userAgent;
    var isAndroid = UA.indexOf('Android') > 0;
    var isIOS = /iPhone|iPad|iPod|iOS/.test(UA);
    var isXinhunan = false;
     var isHarmony = UA.indexOf('OpenHarmony') > 0;
    if (isAndroid || isIOS||isHarmony) {
    //确定是在安卓,苹果手机中再判断是否在新湖南(ios 12 UA会写入失败，这里忽略)
    if(UA.substring(0, 4) === "xhn-" || UA.startsWith("Mozilla/5.0 (iPhone; CPU iPhone OS 12"))
    {
        isXinhunan = true;
    }	
    }
    return isXinhunan;
}

onMounted(async() => {
  const el = videoRef.value
  if (el) {
    // 确保静音以满足浏览器自动播放策略
    el.muted = true
    // 触发播放
    el.play().catch(() => {})
  }
})

const getPoster =  async()=>{
  showLoadingToast({
  message: '加载中...',
  forbidClick: true,
  duration: 0,
});
  let qrcodeUrl = await QRCode.toDataURL("https://h5cgi.voc.com.cn/h5/hudong/2026/tenfivefive/#/")
  qrcode_url.value = qrcodeUrl
  // 阻塞等待二维码生成完成
  await new Promise(resolve => setTimeout(resolve, 300))
  let canvas_dom = await html2canvas(poster_ref.value)
  const base64Data = canvas_dom.toDataURL("image/jpeg");
  const file = base64ToFile(base64Data, `poster_${Date.now()}.jpg`);
  const token_res = await fetch('https://zh.voc.com.cn/api/xhn/token.php?topicid=156').then(res => res.json())
  if(token_res.status === 1){
    const qiniu_data = JSON.parse(token_res.data)
    console.log(qiniu_data)
     // 上传到七牛云
        const config = {
            useCdnDomain: true,
            disableStatisticsReport: true,
            uphost: qiniu_data.data.up_host,
        }
        const key = qiniu_data.data.file_key
        var observer = {
            next(res) {
                console.log('进度', res);
            },
            error(err) {
                console.log('报错', err);
                closeToast();
            },
            complete: (res) => {
              console.log('上传完成', res);
              console.log(qiniu_data.data.visit_url+'/'+res.key)
              let url = qiniu_data.data.visit_url+'/'+res.key
              if(is_xhn()){
                let post_data = {
                  "share_title": "H5｜出发！湖南“十五五”时光体验官",
                  "share_des": "循着“十五五”宏伟蓝图，解锁你日常里的未来彩蛋。",
                  "share_img": url,
                  "share_url": 'https://h5cgi.voc.com.cn/h5/hudong/2026/tenfivefive/#/',
                  "content_type": "2",
                  "poster_img": url,
                  "share_type": "0"
                }
                vmobile.beginCutomerShare(JSON.stringify(post_data))
              }else{
                showSaveDialog.value = true
                poster_url.value = url
              }
               closeToast()
            },
        };
        let observable = qiniu.upload(
            file,
            key,
            qiniu_data.data.token,
            {},
            config
        );
        observable.subscribe(observer);
  }else{
    showToast('获取token失败')
  }
}

// 将base64转换为File对象的辅助函数
function base64ToFile(base64String, filename) {
  // 分离base64数据和元数据
  const arr = base64String.split(',');
  const mimeMatch = arr[0].match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  
  return new File([u8arr], filename, { type: mime });
}



const GotoDetailView = async () => {
  // 尝试播放音乐

  
  // 跳转到详情页面
  router.push({
    path: '/detail',
  })
}

const GotoRuHuaView = async () => {
  showAlert.value = true
}

const closeAlert = () => {
  showAlert.value = false
}

const onClickHaibao = () => {
  // showAlert.value = false
  getPoster()
}

const onClickJixu = () => {
  showAlert.value = false
  router.push({
    path: '/choose',
  })
}

// 打开长按保存弹窗
const openSaveDialog = () => {
  if (poster_url.value) {
    showSaveDialog.value = true
  } else {
    showToast('海报尚未生成，请稍候...')
  }
}

// 关闭长按保存弹窗
const closeSaveDialog = () => {
  showSaveDialog.value = false
}


</script>

<style lang="scss" scoped>
.poster-content{
  position: fixed;
  left: 999px;
  z-index: -1;
}
.qrcode{
  position: absolute;
  left: 50%;
  bottom: 111px;
  width: 160px;
  height: 160px;
  margin-left: -80px;
}
.detail-container {
  // background-image: url('../assets/nav_bg.jpg');
  background: #36CDF8;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  position: relative; /* 关键：作为定位父级 */
  height: 100vh; /* 根据需求调整高度 */
  width: 100%; /* 根据需求调整宽度 */
  display: flex;
  flex-direction: column; /* 垂直排列 */
  box-sizing: border-box;
  justify-content: center; /* 确保子元素从顶部开始排列 */
  align-items: center; /* 水平居中对齐子元素 */
  overflow: hidden;
  &>video{
    width: 100%;
    height: 100vh;
    object-fit: cover;
    position: fixed;
    left: 0;
    top: 0;
    @media screen and (min-width: 1024px){
        max-width: 677px !important;
        margin: auto !important;
        left: 50%;
        transform: translateX(-50%);
    }
  }
}
.video-container{
  position: fixed;
  width: 100vw;
  padding-top: 177.78vw; /* 9:16 比例 */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;
  box-sizing: border-box;
  @media screen and (min-width: 1024px){
        max-width: 677px !important;
        margin: auto !important;
    }
}

.video-container video{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.detail-content{
  position: absolute;
  left: 50%;
  top: 90px;
  transform: translateX(-50%);
  z-index: 2;
  padding-top: 30px;
  @media screen and (min-width: 1024px){
    padding: 0;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .ruhua-button{
    background-image: url('../assets/detail/button_ruhua.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 250px;
    height: 76px;
      /* 水平居中 */
    position: absolute;
    left: 50%;
    bottom: -150px;
    transform: translateX(-50%);
    z-index: 3;
}
}

.detail-img{
  width: auto;
  height: auto;
  max-width: 90vw;
  max-height: 70vh;
  object-fit: contain;
  display: block;
}

/* 为每个detail图片设置特定宽度 */
.detail-img-01 {
  width: 649px; /* 根据实际图片尺寸调整 */
  height: auto;
}

.detail-img-02 {
  width: 613px; /* 根据实际图片尺寸调整 */
  height: auto;
}

.detail-img-03 {
  width: 613px; /* 根据实际图片尺寸调整 */
  height: auto;
}

.detail-img-04 {
  width: 542px; /* 根据实际图片尺寸调整 */
  height: auto;
}

.detail-img-05 {
  width: 698px; /* 根据实际图片尺寸调整 */
  height: auto;
}

.detail-img-06 {
  width: 684px; /* 根据实际图片尺寸调整 */
  height: auto;
}

.detail-img-07 {
  width: 576px; /* 根据实际图片尺寸调整 */
  height: auto;
}

.detail-img-08 {
  width: 649px; /* 根据实际图片尺寸调整 */
  height: auto;
}

.detail-img-09 {
  width: 540px; /* 根据实际图片尺寸调整 */
  height: auto;
}

.detail-img-10 {
  width: 541px; /* 根据实际图片尺寸调整 */
  height: auto;
}

.alert-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.alert-content {
  position: relative;
  display: inline-block;
}

.alert-image {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
}

.alert-actions {
  position: absolute;
  left: 50%;
  bottom: 100px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.alert-btn {
  width: 250px;
  height: 76px;
  object-fit: contain;
  cursor: pointer;
}

.save-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
}

.save-dialog-content {
  background: white;
  border-radius: 12px;
  padding: 24px;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  text-align: center;
  position: relative;
}

.save-dialog-text {
  font-size: 16px;
  color: #333;
  margin-bottom: 16px;
  font-weight: bold;
}

.save-dialog-image {
  width: 100%;
  max-width: 300px;
  height: auto;
  border-radius: 8px;
  margin: 10px 0;
  border: 1px solid #eee;
}

.save-dialog-tip {
  font-size: 14px;
  color: #666;
  margin: 16px 0;
  line-height: 1.5;
}

.save-dialog-close {
  background: #007AFF;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 16px;
  width: 100%;
  max-width: 200px;
}
</style>
